import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

import type { DataLayer, SignedInUser } from './ports.ts';

const DataContext = createContext<DataLayer | null>(null);

export function DataProvider({ data, children }: { data: DataLayer; children: ReactNode }) {
  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
}

export function useData(): DataLayer {
  const data = useContext(DataContext);
  if (!data) throw new Error('useData must be used inside <DataProvider>.');
  return data;
}

// undefined while Firebase restores the session, null when signed out.
export function useCurrentUser(): SignedInUser | null | undefined {
  const { auth } = useData();
  const [user, setUser] = useState<SignedInUser | null | undefined>(() => auth.current() ?? undefined);
  useEffect(() => auth.onChange(setUser), [auth]);
  return user;
}
